import { TagProps } from "@chakra-ui/react";
import { Email } from "features/Resources/Email/models";
import { blueStyles, errorStyles, grayStyles, greenStyles } from "components/Tag/Status/styles";
import { titleize } from "helpers/string";
import BaseActionStatus from "components/Tag/Status/BaseActionStatus";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";

interface EmailStatusProps extends TagProps {
  status: Email["status"];
}

function emailStatusStyles(status: Email["status"]) {
  switch (status) {
    case "delivered":
      return greenStyles;
    case "failed":
      return errorStyles;
    case "skipped":
      return grayStyles;
    case "pending":
      return blueStyles;
    default:
      return {};
  }
}

export function ShortEmailStatus({ status, ...rest }: EmailStatusProps) {
  if (status === "pending") return null;
  return (
    <BaseActionStatus {...emailStatusStyles(status)} {...rest}>
      {titleize(status)}
    </BaseActionStatus>
  );
}

export function FullEmailStatus({ status, ...rest }: EmailStatusProps) {
  if (status === "pending") return null;
  return (
    <BaseActionStatus {...emailStatusStyles(status)} {...rest}>
      {titleize(status)}
    </BaseActionStatus>
  );
}

export function ShowEmailStatus({ status, ...rest }: EmailStatusProps) {
  return (
    <HorizontalGreyBlackField label="Status" labelContainerProps={longAttributeStyles.labelContainerProps}>
      <FullEmailStatus status={status} {...rest} />
    </HorizontalGreyBlackField>
  );
}
